import React, { useState, useEffect } from "react";
import axios from "axios";
import LoadingButton from "../Components/LoadingButton.jsx";
function Assignments() {
  const [assignments, setAssignments] = useState([]);
  const [form, setForm] = useState({
    assignmentTitle: "",
    subjectName: "",
    className: "",
    sectionName: "",
    dueDate: "",
    marks: "",
    file: null,
    description: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [teacher, setTeacher] = useState(null);
  const [classId, setClassId] = useState("");
const [sectionId, setSectionId] = useState("");
const [loading, setLoading] = useState(false);

  const labelStyle = "text-black font-semibold mb-1 !text-[18px]";
  const inputStyle =
    "border rounded-lg px-3 py-2 outline-none !text-[14px] placeholder:!text-[14px] focus:ring-2 focus:ring-blue-500";
        const sessionId = localStorage.getItem("currentSessionId");
useEffect(() => {
  const teacherRaw = localStorage.getItem("teacher");
  const sessionId = localStorage.getItem("currentSessionId");
  if (!teacherRaw || !sessionId) {
    console.error("Missing teacher or sessionId");
    return;
  }

  const teacherData = JSON.parse(teacherRaw);
  const teacherId = teacherData.id; 

  if (!teacherId) {
    console.error("Teacher ID missing");
    return;
  }

  const fetchTeacher = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}`,
        { params: { sessionId } }
      );

      setTeacher(res.data);

      const { firstName, lastName } = res.data;
      fetchClasses(`${firstName} ${lastName}`);
    } catch (err) {
      console.error(
        "Error fetching teacher:",
        err.response?.data || err.message
      );
    }
  };

  const fetchAssignments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/assignments/getAssignments`,
        { params: { sessionId } }
      );
      setAssignments(res.data);
    } catch (err) {
      console.error(
        "Error fetching assignments:",
        err.response?.data || err.message
      );
    }
  };

  fetchTeacher();
  fetchAssignments();
}, []);



  const fetchClasses = async (teacherName) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getTeacherClasses/${teacherName}`,
        { params: { sessionId } }
      );
      setClasses(res.data);
    } catch (err) {
      console.error("Error fetching classes:", err);
    }
  };

  const fetchSubjects = async (className) => {
    if (!teacher) return;
    try {
      const { firstName, lastName } = teacher;
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getSubjectsByTeacherAndClass/${firstName}%20${lastName}/${className}`,
        { params: { sessionId } }
      );
      if (Array.isArray(res.data.subjects)) setSubjects(res.data.subjects);
      else setSubjects([]);
    } catch (err) {
      console.error("Error fetching subjects:", err);
    }
  };

  useEffect(() => {
    if (form.className) fetchSubjects(form.className);
  }, [form.className]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "className") {
      const [className, sectionName] = value.split("|");
      setForm({ ...form, className, sectionName });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleFileChange = (e) => {
    setForm({ ...form, file: e.target.files[0] });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  const sessionId = localStorage.getItem("currentSessionId");
  const teacherData = JSON.parse(localStorage.getItem("teacher"));

  if (!sessionId || !teacherData?.id) {
    console.error("Missing sessionId or teacherId");
    return;
  }

  const payload = new FormData();

  // Add all form fields (title, description, className, etc.)
  Object.entries(form).forEach(([key, value]) => {
    if (value) payload.append(key, value);
  });

  // ✅ Add teacherId
  payload.append("teacherId", teacherData.id);

  // ✅ Add sessionId in body (required by backend)
  payload.append("sessionId", sessionId);

  try {
    if (editingId) {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/assignments/updateAssignment/${editingId}`,
        payload
      );
      alert("Assignment updated successfully!");
    } else {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/assignments/createAssignment`,
        payload
      );
      alert("Assignment created successfully!");
    }

    clearForm();

    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/assignments/getAssignments`,
      { params: { sessionId } } // GET still uses query param
    );
    setAssignments(res.data);

  } catch (err) {
    console.error(
      "Error saving assignment:",
      err.response?.data || err.message
    );
  }finally {
    setLoading(false);
  }
};



  const handleEdit = (a) => {
    setForm({
      assignmentTitle: a.assignmentTitle || "",
      subjectName: a.subjectName || "",
      className: a.className || "",
      sectionName: a.sectionName || "",
      dueDate: a.dueDate ? a.dueDate.split("T")[0] : "",
      marks: a.marks || "",
      file: null,
      description: a.description || "",
    });
    setEditingId(a._id);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this assignment?")) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_BASE_URL}/api/assignments/deleteAssignment/${id}`,
          { params: { sessionId } }
        );
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/assignments/getAssignments`,
          { params: { sessionId } }
        );
        setAssignments(res.data);
      } catch (err) {
        console.error("Error deleting assignment:", err);
      }
    }
  };

  const clearForm = () => {
    setForm({
      assignmentTitle: "",
      subjectName: "",
      className: "",
      sectionName: "",
      dueDate: "",
      marks: "",
      file: null,
      description: "",
    });
    setEditingId(null);
  };

  const getFilteredAssignments = () =>{
    if (!form.className || !form.subjectName) return [];
    return assignments.filter(
      (a) =>
        (!form.className || a.className === form.className) &&
        (!form.sectionName || a.sectionName === form.sectionName) &&
        (!form.subjectName || a.subjectName === form.subjectName)
    );
  }
    

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <i className="fas fa-tasks text-yellow-500 !text-[20px]" />
          <h1 className="font-bold !text-[18px]">Manage Assignments</h1>
        </div>
        {editingId && (
          <span className="text-sm text-gray-500">
            Editing assignment –{" "}
            <span className="font-semibold">Update mode</span>
          </span>
        )}
      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="space-y-6 mb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Class */}
          <div className="flex flex-col">
            <label className={labelStyle}>Class:</label>
            <select
              name="className"
              value={
                form.className && form.sectionName
                  ? `${form.className}|${form.sectionName}`
                  : ""
              }
              onChange={handleInputChange}
              className={inputStyle}
            >
              <option value="">Select Class</option>
              {classes.map((cls) => (
                <option
                  key={cls._id}
                  value={`${cls.className}|${cls.sectionName}`}
                >
                  {cls.className} ({cls.sectionName})
                </option>
              ))}
            </select>
          </div>

          {/* Subject */}
          <div className="flex flex-col">
            <label className={labelStyle}>Subject:</label>
            <select
              name="subjectName"
              value={form.subjectName}
              onChange={handleInputChange}
              disabled={!form.className}
              className={inputStyle}
            >
              <option value="">Select Subject</option>
              {subjects.map((sub, idx) => (
                <option key={idx} value={sub}>
                  {sub}
                </option>
              ))}
            </select>
          </div>

          {/* Title */}
          <div className="flex flex-col">
            <label className={labelStyle}>Title:</label>
            <input
              type="text"
              name="assignmentTitle"
              value={form.assignmentTitle}
              onChange={handleInputChange}
              required
              placeholder="Enter assignment title"
              className={inputStyle}
            />
          </div>

          {/* Due Date */}
          <div className="flex flex-col">
            <label className={labelStyle}>Due Date:</label>
            <input
              type="date"
              name="dueDate"
              value={form.dueDate}
              onChange={handleInputChange}
              className={inputStyle}
            />
          </div>

          {/* Marks */}
          <div className="flex flex-col">
            <label className={labelStyle}>Marks:</label>
            <input
              type="number"
              name="marks"
              value={form.marks}
              onChange={handleInputChange}
              placeholder="Total marks"
              className={inputStyle}
            />
          </div>

          {/* File Upload */}
          <div className="flex flex-col">
            <label className={labelStyle}>Upload File:</label>
            <input
              type="file"
              name="file"
              onChange={handleFileChange}
              className={inputStyle}
              required={!editingId}
            />
          </div>

          {/* Description */}
          <div className="flex flex-col md:col-span-2">
            <label className={labelStyle}>Description:</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleInputChange}
              className={`${inputStyle} min-h-[80px] resize-y`}
              rows="2"
              placeholder="Assignment details (optional)"
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-start gap-4 mt-4">
          <LoadingButton
  type="submit"
  loading={loading}
  text={editingId ? "Update Assignment" : "Add Assignment"}
  loadingText={editingId ? "Updating..." : "Submitting..."}
  className="bg-blue-500 hover:bg-blue-600 text-white !text-[14px]"
/>

          {editingId && (
            <button
              type="button"
              onClick={clearForm}
              className="bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-lg !text-[14px]"
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      {/* TABLE / LIST CARD */}
      <div className="bg-white shadow-lg rounded-lg p-6">
        <h2 className="font-semibold mb-4 flex items-center gap-2 !text-[18px] text-gray-900">
          <i className="fas fa-list-alt text-blue-500 !text-[18px]" />
          Assignments
        </h2>

        {/* Desktop Table */}
        <div className="overflow-x-auto hidden md:block">
          <table className="min-w-full border border-gray-300 text-center !text-[14px]">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                {["#", "Title", "Class", "Subject", "Marks", "Due", "Actions"].map(
                  (h) => (
                    <th
                      key={h}
                      className="px-4 py-2 border font-semibold whitespace-nowrap"
                    >
                      {h}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody className="bg-white">
              {getFilteredAssignments().length ? (
                getFilteredAssignments().map((a, i) => (
                  <tr
                    key={a._id}
                    className="hover:bg-gray-50 border-b transition-colors"
                  >
                    <td className="px-4 py-2 border">{i + 1}</td>
                    <td className="px-4 py-2 border">
                      {a.assignmentTitle}
                    </td>
                    <td className="px-4 py-2 border">
                      {a.className} ({a.sectionName})
                    </td>
                    <td className="px-4 py-2 border">{a.subjectName}</td>
                    <td className="px-4 py-2 border">{a.marks}</td>
                    <td className="px-4 py-2 border">
                      {a.dueDate
                        ? new Date(a.dueDate).toLocaleDateString()
                        : "-"}
                    </td>
                    <td className="px-4 py-2 border">
                      <div className="flex justify-center gap-3">
                        <button
                          onClick={() => handleEdit(a)}
                          className="text-yellow-600 hover:underline"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(a._id)}
                          className="text-red-600 hover:underline"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="py-3 text-gray-500 text-center border"
                  >
                    No assignments found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="grid grid-cols-1 md:hidden gap-4">
          {getFilteredAssignments().length ? (
            getFilteredAssignments().map((a) => (
              <div
                key={a._id}
                className="bg-white shadow-sm rounded-lg p-4 border border-gray-200"
              >
                <h3 className="font-bold !text-[16px] text-blue-800 mb-1">
                  {a.assignmentTitle}
                </h3>
                <p className="!text-[14px] text-gray-700">
                  📘 {a.subjectName} • {a.className} ({a.sectionName})
                </p>
                <p className="!text-[14px] mt-1">
                  🗓{" "}
                  {a.dueDate
                    ? new Date(a.dueDate).toLocaleDateString()
                    : "No due date"}
                </p>
                <p className="!text-[14px]">⭐ Marks: {a.marks || "-"}</p>
                <div className="flex justify-end mt-3 gap-3 !text-[14px]">
                  <button
                    onClick={() => handleEdit(a)}
                    className="text-yellow-600 hover:underline"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(a._id)}
                    className="text-red-600 hover:underline"
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 !text-[14px]">
              No assignments found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Assignments;
